import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SaveChangesModalTestIds } from '@pages/security/components/save-changes-modal/save-changes-modal.test-ids';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DialogActionsComponent,
  DialogComponent,
  DialogHeaderComponent,
  injectDialogReference,
  RegularButtonComponent,
} from '@kaseya-design-components';

@Component({
  selector: 'itc-save-changes-modal',
  templateUrl: 'save-changes-modal.component.html',
  styleUrl: 'save-changes-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RegularButtonComponent, TranslatePipe, DialogHeaderComponent, DialogActionsComponent, DialogComponent],
})
export class SaveChangesModalComponent {
  private readonly dialogReference = injectDialogReference();

  readonly testIds = SaveChangesModalTestIds;

  onCancelButton(): void {
    this.dialogReference.dismiss();
  }

  onOkButton(): void {
    this.dialogReference.confirm();
  }
}
